// dynamic-text.js
;(({ $$ }) => {
    const activeClass = 'dynamic-text--active'
    $$('.dynamic-text').forEach(dt => {
        const dynamic = dt.querySelector('.dynamic-text__dynamic')
        if (!dynamic) return

        dt.querySelectorAll('.dynamic-text__trigger').forEach(trigger => {
            trigger.addEventListener('click', e => {
                e.preventDefault()
                dt.classList.toggle(activeClass)
                dynamic.slideToggle(300)
            })
        })
    })
})(CNS);